import React, { Component } from 'react';

class TextBlock extends Component {
  render(){
    const { captionMode = '' } = this.props;

    return(
      <div>
        {captionMode !== ''
          ? <p className="caption" style={{whiteSpace: 'pre-line'}}>{this.props.text}</p>
          : <p style={{whiteSpace: 'pre-line'}}>{this.props.text}</p>
        }
      </div>
    );
  }
}

export default TextBlock;



// WEBPACK FOOTER //
// ./src/layout/TextBlock.js